import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import jQuery from 'jquery';
import {TechnicalCompetence} from '../../shared/technical-competence';

@Component({
    selector: 'occupational-profile-competence-item',
    templateUrl: './occupational-profile-competence-item.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OccupationalProfileCompetenceItemComponent {

    @Input()
    public index!: number;
    @Input()
    public competence!: TechnicalCompetence;
    public competenceSelected = false;

    clickAccordionHeader(competence: TechnicalCompetence, event: any): void {
        this.toggleAccordion(event.target);
        this.competenceSelected = !this.competenceSelected;
    }

    toggleAccordion(element: any): void {
        (jQuery||$)(element).closest('.c-accordion__header').siblings('.c-accordion__content').slideToggle(150);

        const isAriaExp = (jQuery||$)(element).find('.c-accordion__button').attr('aria-expanded');
        const newAriaExp = (isAriaExp === "false") ? "true" : "false";
        (jQuery||$)(element).find('.c-accordion__button').attr('aria-expanded', newAriaExp);

        const isAriaHidden  = (jQuery||$)(element).closest('.c-accordion__header').siblings('.c-accordion__content').attr('aria-hidden');
        const newAriaHidden = (isAriaHidden === "true") ? "false" : "true";
        (jQuery||$)(element).closest('.c-accordion__header').siblings('.c-accordion__content').attr('aria-hidden', newAriaHidden);
    }

    hasKnowledgeOrBehaviouralIndicator(): boolean {
        return this.competence.knowledgeItems?.length > 0 || this.competence.behaviouralIndicators.length > 0;
    }

}
